import { z } from 'zod';

export const formSchema = z.object({
  titulo: z.string().min(3, 'El título debe tener al menos 3 caracteres'),
  subtitulo: z.string().min(3, 'El subtítulo debe tener al menos 3 caracteres'),
  descripcion: z.string().optional(),
  imagen: z.string().optional(),
  imageKey: z.string().optional(),
  tipo: z.enum(['sencilla', 'producto', 'partida']).default('sencilla'),
  tipoId: z.string().optional(),
  tipoProgramacion: z.enum(['inmediato', 'unico', 'recurrente']).default('inmediato'),
  destinatarios: z.literal('todos').default('todos'),
}).superRefine((data, ctx) => {
  if (data.tipo !== 'sencilla' && !data.tipoId) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['tipoId'],
      message: 'Captura el ID del destino',
    });
  }
});
